/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_OrganizationMetadataPropertyUpdateRequest = {
    default_value?: any;
    description?: string;
    label: string;
    options?: Array<string>;
    required?: boolean;
    type: models_OrganizationMetadataPropertyUpdateRequest.type;
};
export namespace models_OrganizationMetadataPropertyUpdateRequest {
    export enum type {
        STRING = 'string',
        NUMBER = 'number',
        BOOLEAN = 'boolean',
        SELECT = 'select',
    }
}

